import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

export function useE09Finalize() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (fileId: number) => {
      const response = await axios.get(`/data-set/e09/finalize`, {
        params: {
          dataSet: fileId
        }
      });
      return response.data;
    },
    onSuccess: () => {
      // Invalidate relevant queries to trigger refetch
      queryClient.invalidateQueries({ queryKey: ['e09Samples'] });
      queryClient.invalidateQueries({ queryKey: ['e09FileDetails'] });
    }
  });
} 